import './ManageEnvironments.scss';
import InfoBubble from 'components/chrome/InfoBubble';
import Card from 'components/chrome/Card';
import Environment from 'models/Environment';
import Tag from 'components/chrome/Tag';
import React from 'react';
import moment from 'moment';
import { Button } from 'primereact/button';


const ENVIRONMENTS = [
  new Environment({
    name: 'prod',
    url: 'api.optigrab.axle-medical.com',
    moduleVersion: '2.1.0',
    apiVersion: '0.2.0',
    trafficUsage: '22k weekly active devices',
    customHooksInUse: ['onStreamCommit', 'onDailyAsync'],
  }),
  new Environment({
    name: 'beta',
    url: 'api-beta.optigrab.axle-medical.com',
    moduleVersion: '2.1.0',
    apiVersion: '1.0.0',
    trafficUsage: '9 weekly active devices',
    customHooksInUse: ['onStreamCommit', 'onDailyAsync'],
  }),
  new Environment({
    name: 'dev',
    url: 'api-dev.optigrab.axle-medical.com',
    moduleVersion: '2.1.0',
    apiVersion: '1.0.0',
    trafficUsage: '158 weekly active devices',
    customHooksInUse: ['onStreamCommit', 'onDailyAsync', 'onNewDeviceSerialRegistered'],
  }),
];


const dataTemplates = {
  date: i => (
    moment(i).format('LLL')
  ),
  list: i => (
    <div>
      {i.map(j => <div className='listItem' key={j}>{j}</div>)}
    </div>
  )
};


class ManageEnvironments extends React.Component {
  constructor() {
    super();
    this.state = { environments: ENVIRONMENTS };
  }

  renderLabelValue(label, value, extras) {
    // extras: { labelInfo, valueTemplate }
    return (
      <div className='labelValue'>
        <div className='label'>
          {label}
          {extras.labelInfo ? (<InfoBubble text={extras.labelInfo} />) : ''}
        </div>
        <div className='value'>
          {(extras.valueTemplate || (i => i))(value)}
        </div>
      </div>
    );
  }

  renderEnvironmentQuickLinks() {
    return (
      <div className='environmentQuickLinks'>
        <div>
          Current status
        </div>
        <div className='status'>
          <Tag label='healthy' className='statusTagHealthy' />
        </div>
        <Button label='Monitoring' icon='pi pi-chevron-right' iconPos='right' />
        <Button label='View logs' icon='pi pi-chevron-right' iconPos='right'/ >
      </div>
    );
  }

  renderEnvironment(environment) {
    return (
      <div className='section' key={environment.name}>
        <Card
            header={`Environment configuration: ${environment.name}`}
            text={this.renderEnvironmentQuickLinks()}
            childrenPadded>
          {this.renderLabelValue(
              'Last modified',
              new Date(2020, 3, 6, 12, 10),
              { valueTemplate: dataTemplates.date, })}
          {this.renderLabelValue(
              'URL',
              environment.url,
              { valueTemplate: dataTemplates.url, })}
          {this.renderLabelValue(
              'Module version',
              environment.moduleVersion,
              { labelInfo: "Software version of the environment backend server", })}
          {this.renderLabelValue(
              'API version',
              environment.apiVersion,
              { labelInfo: "Version of the environment's interface", })}
          {this.renderLabelValue(
              'Custom hooks',
              environment.customHooksInUse,
              { valueTemplate: dataTemplates.list, })}
          <div className='modifyButton'>
            <Button label='Modify' icon='pi pi-pencil' iconPos='right' />
          </div>
        </Card>
      </div>
    );
  }

  render() {
    return (
      <div className='ManageEnvironments'>
        <div className='section'>
          <div className='subtitle'>
            Environments
          </div>
          <p>
            View and configure your environments.
          </p>
          <p>
            Your current plan allows you to have three environments: Production, Beta, and Development.
          </p>
        </div>
        {this.state.environments.map(this.renderEnvironment.bind(this))}
      </div>
    );
  }
}


export default ManageEnvironments;
